// usePostEndorsement
import { useMutation, useQueryClient } from 'react-query';
import { useDispatch } from 'react-redux';
import isEmpty from 'lodash/isEmpty';

import { quoteBindAxios } from 'lib/quoteBind';
import { QB_RISK_ENDORSEMENTS, RISKS } from 'lib/quoteBind/queryKeys';
// app
import { enqueueNotification, hideModal } from 'stores';
import * as utils from 'utils';
import { logoutAuth0 } from 'utils/auth0/auth0';

// risks
export const usePatchEndorsement = () => {
  const dispatch = useDispatch();
  const queryClient = useQueryClient();

  const handleError = (err) => {
    const errorParams = {
      file: 'quoteBind.mutations.usePatchEndorsement',
    };

    dispatch(enqueueNotification('notification.patchEndorsement.fail', 'error'));

    utils.api.handleError(err, errorParams);
    utils.api.handleUnauthorized(err, null, logoutAuth0);
  };

  const handleSuccess = (res) => {
    queryClient.invalidateQueries(RISKS, res.riskId);
    queryClient.invalidateQueries(QB_RISK_ENDORSEMENTS, res.riskId);

    dispatch(hideModal());
    dispatch(enqueueNotification('notification.patchEndorsement.success', 'success'));
  };

  return useMutation(
    async (params) => {
      const { values, definitions, riskId, riskData, effectiveDate, endorsementId } = params;

      if (!values || !endorsementId || isEmpty(values) || !utils.generic.isValidArray(definitions)) {
        throw new Error('Invalid params');
      }

      const riskDataParsed = {
        ...utils.risk.parsedValues(utils.risk.filterConditionalValues(values, definitions), definitions),
      };

      const { comments, inceptionDate, ...risk } = riskDataParsed;

      const data = {
        risk: {
          ...riskData,
          ...risk,
        },
        riskId,
        comments,
        effectiveFrom: utils.date.startOf(effectiveDate, 'day'),
      };

      const result = await quoteBindAxios.patch(`/risks/${riskId}/endorsements/${endorsementId}`, data);
      return result?.data;
    },
    {
      onSuccess: (res) => handleSuccess(res),
      onError: (err) => handleError(err),
      keepPreviousData: true,
    }
  );
};
